import { groupBy, keys } from 'lodash'
import { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { CopyToClipboard, CopyToClipboardWrapper } from '@10xLabs/react-web/components/CopyToClipboard'
import Heading from 'components/v2/Heading'
import { StyledLink } from 'components/v2/Link'
import Modal from 'components/v2/Modal'
import { TableContainer, Table, Thead, Th, Tbody, Tr, Td } from '@10xLabs/react-web/components/Table'
import { passengerTypeMessages } from 'features/Bookings/components/PassengerType/messages'
import { safeFormatMessage } from 'utils/intl'
import { GTBookingV2, GTBookingV2TicketStatus } from 'gql/types.generated'

interface IDrawerCancelledTicketsProps {
  bookings: GTBookingV2[]
}

export const DrawerCancelledTickets = function ({ bookings = [] }: IDrawerCancelledTicketsProps): TSFixMe {
  const intl = useIntl()
  const [isModalOpen, setModalOpen] = useState(false)

  const bookingsWithCancelledTickets = bookings.map((booking) => {
    return {
      ...booking,
      tickets: booking.tickets.filter((ticket) => ticket?.status === GTBookingV2TicketStatus.Cancelled)
    }
  })
  const cancelledTicketsCount = bookingsWithCancelledTickets.reduce((count, booking): TSFixMe => {
    return count + booking.tickets.length
  }, 0)

  return (
    <>
      {cancelledTicketsCount > 0 ? (
        <div>
          <StyledLink onClick={(): TSFixMe => setModalOpen(true)}>{cancelledTicketsCount}</StyledLink>
        </div>
      ) : (
        0
      )}
      {isModalOpen && (
        <Modal.Container large>
          <Modal.Header onClose={(): TSFixMe => setModalOpen(false)}>
            <Heading.H5>
              <FormattedMessage id="drawer.cancelledTickets.title" defaultMessage="Cancelled tickets" />
            </Heading.H5>
          </Modal.Header>
          <Modal.Content>
            <TableContainer overflow>
              <Table>
                <Thead>
                  <Tr>
                    <Th>
                      <FormattedMessage id="dictionary.id" defaultMessage="Id" />
                    </Th>
                    <Th>
                      <FormattedMessage id="drawer.cancelledTickets.number" defaultMessage="Number of tickets" />
                    </Th>
                    <Th>
                      <FormattedMessage id="drawer.cancelledTickets.type" defaultMessage="Type tickets" />
                    </Th>
                    <Th>
                      <FormattedMessage id="dictionary.coupon" defaultMessage="Coupon" />
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {bookingsWithCancelledTickets.map((booking, index): TSFixMe => {
                    const ticketsGroupedByPassengerType = groupBy(booking.tickets, 'passengerType')
                    return keys(ticketsGroupedByPassengerType).map((passengerType): TSFixMe => {
                      return (
                        <Tr key={index}>
                          <Td>
                            <CopyToClipboardWrapper>
                              <div>{booking.id.substring(0, 8)}</div>
                              <CopyToClipboard str={booking.id} />
                            </CopyToClipboardWrapper>
                          </Td>
                          <Td>{ticketsGroupedByPassengerType[passengerType].length}</Td>
                          <Td>{safeFormatMessage({ intl, messages: passengerTypeMessages, key: passengerType })}</Td>
                          <Td>{booking.coupon?.code}</Td>
                        </Tr>
                      )
                    })
                  })}
                </Tbody>
              </Table>
            </TableContainer>
          </Modal.Content>
        </Modal.Container>
      )}
    </>
  )
}
